import { Fragment, useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { notify } from './components/Toast';
import { apiEndpoint } from './constants/api';
import CompanyModal from './components/CompanyModal';
import { CompanySearchTable } from './components/CompanySearchTable';
import Header from './components/Header';
import Aside from './components/Aside';
import ProdzFooter from './components/Footer';
import Nav from './components/Nav';

const connector = connect(
  (state, ownProps) => ({
    ...state.user,
    employer: { ...state.user.currentEmployer },
  }),
  {}
);
function CompanySearch({ user, employer }) {
  const [isOpened, setIsOpened] = useState(false);
  const [companyData, setCompanyData] = useState([]);
  const [activeCompany, setActiveCompany] = useState({ name: '' });
  const [query, setQuery] = useState('');
  const [searching, setSearching] = useState(false);
  const timeout = useRef();
  const uploadPath = apiEndpoint(`/admin/company/logos/${employer.value}`);

  const onSubmit = (evt) => {
    evt.preventDefault();
  };

  const findCompanyData = async ({ target: { value } }) => {
    setSearching(true);
    clearTimeout(timeout.current);
    setQuery(value);
    timeout.current = setTimeout(() => loadCompanyData(value), 700);
  };

  const loadCompanyData = async (q) => {
    const { data } = await axios.get(
      apiEndpoint(`/admin/job-posting/logos${q ? `?q=${q}` : ''}`)
    );
    setCompanyData(data);
    setSearching(false);
    return data;
  };

  const updateActiveCompany = async (updatedData) => {
    if (activeCompany.id) {
      // Update existing company
      try {
        const updatedCompany = { ...activeCompany, ...updatedData };

        await axios.put(
          apiEndpoint(`/admin/company/${activeCompany.id}`),
          updatedCompany
        );
        notify('Company successfully updated!');
        setActiveCompany(updatedCompany);
      } catch (error) {
        console.error('Update failed:', error);
        notify('Failed to update company');
      }
    } else if (updatedData.company_name) {
      // Create new company

      try {
        const response = await axios.post(
          apiEndpoint(`/admin/company`),
          updatedData
        );
        const { data: responseData } = response;
        notify('Company successfully created!');
        setActiveCompany({ ...updatedData, id: responseData.data.id });
      } catch (error) {
        console.error('Company Creation failed:', error);
        notify('Failed to create company');
      }
    }

    // Reload the company data
    loadCompanyData();
  };

  // const saveCompanyData = async () => {
  //   console.log('inside save company data');
  //   const { data } = await axios.post(
  //     apiEndpoint('/admin/company'),
  //     activeCompany
  //   );
  //   loadCompanyData();
  //   closeModal();
  // };

  const createNewCompany = () => {
    setActiveCompany({ name: '', company_name: '' });
    setIsOpened(true);
  };

  const closeModal = () => {
    setIsOpened(false);
  };

  const onEditCompany = ({ company }) => {
    setActiveCompany(company);
    setIsOpened(true);
  };

  const onLogoUploadComplete = async (data) => {
    notify('Company Logo successfully updated!');
  };

  useEffect(() => {
    loadCompanyData();
  }, []);

  return (
    <>
      <Helmet>
        <title>Company Search | Productions.com</title>
      </Helmet>
      <div className="min-h-full">
        <Nav />
        <>
          <Header publicId={employer.logo} />
          <Aside />
          <main className="p-4 sm:ml-64">
            <div className="mx-auto sm:px-6 lg:px-8">
              {/* Replace with your content */}
              <div className="flex flex-row justify-between content-start mb-3">
                <h1 className="text-2xl">Companies</h1>
                <button
                  type="button"
                  onClick={createNewCompany}
                  className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2"
                >
                  + New Company
                </button>
              </div>
              <div>
                <div className="pb-2">
                  <form onSubmit={onSubmit}>
                    <label
                      htmlFor="project-search"
                      className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
                    >
                      Search
                    </label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg
                          aria-hidden="true"
                          className="w-5 h-5 text-gray-500 dark:text-gray-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                          ></path>
                        </svg>
                      </div>
                      <input
                        onChange={findCompanyData}
                        type="search"
                        id="project-search"
                        className="block w-full p-6 px-10 text-lg text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Search Companies..."
                        required
                      />
                    </div>
                  </form>
                </div>
                {companyData && companyData.length ? (
                  <CompanySearchTable
                    companyData={companyData}
                    loadCompanyData={loadCompanyData}
                    searching={searching}
                    onEditCompany={onEditCompany}
                  />
                ) : (
                  <div className="w-full">
                    <div className="mx-auto">Loading Companies...</div>
                  </div>
                )}
              </div>
              <CompanyModal
                isOpened={isOpened}
                activeCompany={activeCompany}
                closeModal={closeModal}
                updateActiveCompany={updateActiveCompany}
                onLogoUploadComplete={onLogoUploadComplete}
              />
              {/* /End replace */}
            </div>
            <ProdzFooter />
          </main>
        </>
      </div>
    </>
  );
}

export default connector(CompanySearch);
